// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ThemeProvider } from './lib/themes/ThemeProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfirmHost } from './components/ui/ConfirmDialog';
import { ToastHost } from './components/ui/ToastHost';
import './lib/i18n';
import './styles.css';
import { applyUiPrefs, loadUiPrefs } from './lib/uiPrefs';
import { bootstrapDesignSystem } from './lib/designTheme';
import { installChunkReloadGuard } from './lib/chunkReload';
import { oturumDevriniDinle, oturumuDevralmayiDene } from './store/sekmeArasiOturum';

installChunkReloadGuard();

// Reklam bagindan gelen ziyaretcinin kaynagini ADRES DEGISMEDEN once yakala: React yonlendirmesi
// ?utm_* parametrelerini temizleyince bir daha okunamaz. Kayit formu bunu istekle birlikte gonderir.
void import('./lib/kampanyaTakibi').then((m) => m.kampanyaBilgisiniYakala());
// Tema ve arayüz tercihleri İLK BOYAMADAN ÖNCE uygulanır — sonraya bırakılırsa ekran açık
// temayla açılıp koyuya atlar (göze çarpan sıçrama).
applyUiPrefs(loadUiPrefs());
bootstrapDesignSystem();

// Bunlar ilk ekranın çizilmesi için GEREKLİ DEĞİL; ana pakete girdiklerinde kendi bağımlılık
// ağaçlarını (entityService, metadataService, sözlük) da giriş ekranına taşıyorlardı. Ölçüm
// 2026-08-31: giriş ekranı LCP 749 ms ve bunun 743 ms'i render gecikmesiydi (sunucu 6 ms).
// Dinamik import ile ayrı parçaya çıkarılıp paralel indiriliyor: iş yine hemen başlar, ama
// indirme/ayrıştırma ilk boyamayı bekletmez. bootstrapPlatform yalnız olay dinleyicisi ve
// lookup çözücüsü kurar (ağır iş yapmaz), bu yüzden mikro gecikme davranışı değiştirmez.
// Dinamik import parçayı ayırdı ama İSTEĞİ ayırmadı: bootstrapPlatform hemen çağrıldığı için
// kendi bağımlılık ağacını (sözleşme/kur çözücüleri, alan widget'ları, entity+metadata servisi)
// giriş ekranı ÇİZİLMEDEN indiriyordu. Ölçüldü 2026-08-31 (dev, /login): ilk boyamadan önce
// 36 dosya / 438 kB iniyordu ve bunun içinde contractsResolver 47 kB, RichTextWidget 20 kB,
// platformBootstrap 16 kB, tarih+telefon widget'ları vardı — giriş formunun hiçbirine ihtiyacı yok.
//
// Artık tarayıcı boşta kalınca kuruluyor. Oturum açılır açılmaz da (App.tsx) hemen çağrılıyor,
// böylece ilk form/liste açılmadan çözücüler yerinde olur; bootstrapPlatform idempotent.
// GIRIS EKRANINDA HIC KURULMAZ (2026-08-31 olcumu): bostaYukle onu ilk boyamanin arkasina
// atmisti ama SILMEMISTI - giris ekraninda hala ~800 kB / 70+ parca (alan widget'lari, sozlesme
// ve kur cozucusu, metadata servisi) arka planda iniyor ve yavas baglantida her seyi geciktiriyordu.
// Oysa oturum acmamis bir ziyaretcinin bunlarin hicbirine ihtiyaci yok: bootstrapPlatform zaten
// giris BASARILI olunca (App.tsx) cagriliyor ve idempotent. Bu yuzden burada YALNIZ kayitli
// oturumu olan (sayfayi yenileyen/geri donen) kullanici icin kurulur.
function oturumVarMi(): boolean {
  try {
    const ham = localStorage.getItem('elpo-core-auth') ?? sessionStorage.getItem('elpo-core-auth');
    if (!ham) return false;
    // ANAHTARIN VARLIGI OTURUM DEMEK DEGIL (2026-09-02): cikis yapildiginda kayit silinmiyor,
    // icindeki jeton null'a cekiliyor. Yalnizca anahtara bakinca giris ekraninda da "oturum var"
    // saniliyor ve platform onyuklemesi jetonsuz istek atiyordu.
    const kayit = JSON.parse(ham) as { state?: { token?: string | null } };
    return !!kayit?.state?.token;
  } catch {
    return false; // gizli sekme / depolama kapali / bozuk kayit: giris ekrani gibi davran
  }
}

void import('./lib/bostaYukle').then(({ bostaYukle }) => {
  if (oturumVarMi()) {
    bostaYukle(() => { void import('./lib/platformBootstrap').then((m) => m.bootstrapPlatform()); });
  }
  // Yazım denetimi: sözlük kurulu değilken Türkçe metinlerin altını çizmesin (varsayılan kapalı).
  bostaYukle(() => { void import('./lib/spellcheck').then((m) => m.yazimDenetiminiBaslat()); });
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('root element bulunamadı');
}

// Menü öğesi Ctrl+tık ile YENİ SEKMEDE açılabilsin (kullanıcı isteği 2026-09-03). Oturum
// "beni hatırla" seçilmediğinde sessionStorage'dadır ve sekmeler arasında paylaşılmaz; yeni
// sekme login'e düşüyordu (ölçüldü). Açık sekmelerden kısa ömürlü devir alınır — oturum diskte
// KALICI durmaz, "tarayıcı kapanınca çıkış" güvencesi korunur. Ayrıntı: sekmeArasiOturum.ts
oturumDevriniDinle();

function uygulamayiCiz() {
  ReactDOM.createRoot(rootElement!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <ErrorBoundary>
        <ThemeProvider>
          <App />
          <ConfirmHost />
          <ToastHost />
        </ThemeProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
  );
}

// Devir denemesi ilk boyamayı en fazla birkaç yüz ms geciktirir ve YALNIZ oturumsuz sekmede
// çalışır (oturumu olan sekme anında çizer).
void oturumuDevralmayiDene()
  .then(async (devralindi) => {
    // Devir sessionStorage'a YAZAR ama authStore modülü zaten yüklenirken okumuştu; kayıt
    // tazelenmezse uygulama oturumsuz sanıp giriş ekranı çizer (ölçüldü: sessionStorage'da
    // oturum vardı, sayfa yine /login'deydi).
    if (!devralindi) return;
    const { useAuthStore } = await import('./store/authStore');
    await useAuthStore.persist.rehydrate();
  })
  .finally(uygulamayiCiz);
